import { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { formatDateTime } from '../../utils/formatters';

export default function NarrativePanel({ fund }) {
  const [narrative, setNarrative] = useState(
    fund?.pipeline_insights || null
  );
  const [generatedAt, setGeneratedAt] = useState(
    fund?.pipeline_insights_generated_at || null
  );
  const [generating, setGenerating] = useState(false);
  const [error, setError] = useState(null);

  async function handleRefresh() {
    if (!fund?.id) return;
    setGenerating(true);
    setError(null);
    try {
      const fns = getFunctions();
      const fn = httpsCallable(fns, 'generatePipelineInsights');
      const result = await fn({ fundId: fund.id });
      setNarrative(result.data.narrative);
      setGeneratedAt(result.data.generated_at);
    } catch (err) {
      console.error('Narrative generation error:', err);
      setError('Unable to generate insights. Please try again.');
    } finally {
      setGenerating(false);
    }
  }

  return (
    <div style={{
      background: 'var(--color-card)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius)',
      overflow: 'hidden',
    }}>
      <div style={{
        padding: '12px 18px',
        background: 'var(--color-sidebar)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: 8,
      }}>
        <div>
          <span style={{ fontWeight: 600, fontSize: 14, color: '#fff' }}>AI Pipeline Insights</span>
          {generatedAt && (
            <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginLeft: 12 }}>
              Last updated: {formatDateTime(generatedAt)}
            </span>
          )}
        </div>
        <button
          onClick={handleRefresh}
          disabled={generating}
          style={{
            padding: '5px 14px',
            borderRadius: 6,
            border: '1px solid rgba(201,149,42,0.5)',
            background: generating ? 'rgba(201,149,42,0.1)' : 'transparent',
            color: 'var(--color-accent)',
            fontSize: 13, cursor: generating ? 'wait' : 'pointer',
          }}
        >
          {generating ? 'Generating…' : 'Refresh Insights'}
        </button>
      </div>

      <div style={{ padding: '16px 18px' }}>
        {generating && (
          <p style={{ fontSize: 14, color: 'var(--color-text-secondary)', fontStyle: 'italic' }}>
            Generating insights…
          </p>
        )}
        {error && !generating && (
          <p style={{ fontSize: 13, color: 'var(--color-error)' }}>{error}</p>
        )}
        {narrative && !generating ? (
          <p style={{ fontSize: 14, lineHeight: 1.75, color: 'var(--color-text)', margin: 0 }}>
            {narrative}
          </p>
        ) : !generating && !error && (
          <p style={{ fontSize: 13, color: 'var(--color-text-secondary)' }}>
            Click <strong>Refresh Insights</strong> to generate an AI-powered narrative analysis of the current pipeline.
          </p>
        )}
      </div>
    </div>
  );
}
